import { render, staticRenderFns } from "./BaseLinkItem.vue?vue&type=template&id=b462b404&scoped=true"
import script from "./BaseLinkItem.vue?vue&type=script&lang=js"
export * from "./BaseLinkItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b462b404",
  null
  
)

export default component.exports